module.exports = __webpack_public_path__ + "static/media/bomb.95119d4a.png";